import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

const Warning = ({
    warningText,
    actionConfirm,
    actionDeny = null,
    title = 'Alert',
    confirmLabel = 'Continue',
    cancelLabel = 'Back',
}) => {
    const el = useRef(null);
    const modalRoot = typeof document !== 'undefined' ? document.body : null;

    useEffect(() => {
        if (el?.current) {
            el.current.focus?.();
        }
        if (typeof document !== 'undefined') {
            document.body.classList.add('warning-modal-open');
        }
        return () => {
            if (typeof document !== 'undefined') {
                document.body.classList.remove('warning-modal-open');
            }
        };
    }, []);

    if (!modalRoot) return null;

    const content = (
        <div className="overlay-warning-portal-wrapper">
            <div className="overlay-warning-backdrop" onClick={actionDeny || (() => {})} />
            <div ref={el} className="overlay-warning warning-modal" role="dialog" aria-modal="true" aria-label={title}>
                <h3 className="warning-modal__title">{title}</h3>
                <div className="warning-modal__body" style={{ whiteSpace: 'pre-line' }}>
                    {warningText}
                </div>
                <div className="warning-modal__actions">
                    {actionDeny && (
                        <button
                            type="button"
                            className="warning-modal__button warning-modal__button--secondary"
                            onClick={actionDeny}
                        >
                            {cancelLabel}
                        </button>
                    )}
                    <button
                        type="button"
                        className="warning-modal__button warning-modal__button--primary"
                        onClick={actionConfirm}
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );

    try {
        if (ReactDOM?.createPortal) return ReactDOM.createPortal(content, modalRoot);
    } catch (e) {
        console.warn('[Warning] createPortal failed, falling back to inline render', e);
    }
    return content;
};

export default Warning;

Warning.propTypes = {
    warningText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    actionConfirm: PropTypes.func.isRequired,
    actionDeny: PropTypes.func,
    title: PropTypes.string,
    confirmLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
};
